// TOP LEVEL IMPORTS
import React from 'react';
// import LabelValueItem from '../LabelValueItem';
import styled from 'styled-components';
import ActionLink from 'components/text/ActionLink';
import Headline from 'components/text/Headline';
import Body from 'components/text/Body';
import DisplayLabel from 'components/text/DisplayLabel';

const Container = styled.div`
  margin-top: 5px;
`;

const LabelValueItem = ({ value, label }) => {
  if (!value) {
    return null;
  }
  return (
    <Container>
      <DisplayLabel>{label}</DisplayLabel>
      <Body>{value}</Body>
    </Container>
  );
};

const EmailLink = ({ email }) => {
  if (!email) {
    return null;
  }
  return (
    <a className="" target="_blank" href={`mailto:${email}`}>
      {email || ''}
    </a>
  );
};

class ClientHeaderCenter extends React.Component {
  render() {
    const { client, onToggleEdit } = this.props;
    const { firstName, lastName, email, description } = client;
    return (
      <div>
        <div style={{ height: 75 }}>
          <Headline className="client-details-name">
            {firstName || ''} {lastName || ''}
          </Headline>
          <ActionLink onClick={onToggleEdit}>EDIT</ActionLink>
        </div>
        <div style={{ height: 75 }}>
          <LabelValueItem value={email && <EmailLink email={email} />} label="EMAIL" />
        </div>
        {description && (
          <div style={{ height: 75 }}>
          <LabelValueItem value={description} label="NOTES" />
        </div>
        )}
      </div>
    );
  }
}

export default ClientHeaderCenter;



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientHeader/ClientHeaderCenter/index.js